// Import Libraries
import React from 'react';
import PropTypes from 'prop-types';
// Import JS modules
import Store from '../_utils/tools/store';
import translate from '../_utils/tools/translate';
// Import JSX modules
import DeliveryOptions from './delivery-options-form-with-callback';
import Modal from '../_utils/modal';

// -----------------------------------------------------------

class DisperateDeliveryOptionsModal extends React.PureComponent {
  static propTypes = {
    options: PropTypes.array.isRequired,
    selectedOption: PropTypes.number.isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
  };

  constructor(props) {
    super();

    this.state = {
      selectedOption: props.selectedOption,
    };
  }

  render() {
    return (
      <Modal
        title="Pick a delivery option"
        className="cart-multiple-delivery-options-modal"
        open={this.props.open}
        maxWidth={750}
        actions={
          <div>
            <button className="btn btn-link" onClick={this.props.onClose}>
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={() => this.props.onSelect(this.state.selectedOption)}>
              Continue
            </button>
          </div>
        }
        onClose={this.props.onClose}>
        <div>
          <p>
            <small>
              It is not currently possible to combine different delivery options
              in the same order. Please select an option below to proceed.
            </small>
          </p>
          <DeliveryOptions
            hideIcon
            options={this.props.options}
            selectedOption={this.state.selectedOption}
            onChange={this.handleChange}
          />
          <p>
            <small>
              Items which are not available for the selected delivery option
              will be removed from your {translate('cart')}.
            </small>
          </p>
          <p>
            <small>
              If you are logged in to a {Store.name} Photo account, removed
              photo gifts will be saved to your{' '}
              <a href="/account/projects">My Projects</a> page.
            </small>
          </p>
        </div>
      </Modal>
    );
  }

  handleChange = ({ key: selectedOption }) => {
    this.setState({
      selectedOption,
    });
  };
}

// -----------------------------------------------------------

export default DisperateDeliveryOptionsModal;
